/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const factory = function (LocalStorageStore) {
  let ClientFilters;
  return (ClientFilters = (function () {
    ClientFilters = class ClientFilters extends LocalStorageStore {
      static initClass() {
        this.prototype.$idName = '$userId'; // prefix with $ to avoid making it part of the $data payload

        this.prototype.accountantId = null;
        this.prototype.bookkeeperId = null;
        this.prototype.bookkeeper2Id = null;
        this.prototype.salespersonId = null;
        this.prototype.salesperson2Id = null;
      }

      $init() {
        // initialize the localStorage if undefined
        if (!this.$fetch()) {
          this.$save({ bookkeeperId: this.$userId });
        }
        return super.$init();
      }
    };
    ClientFilters.initClass();
    return ClientFilters;
  })());
};

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.clientFilters', moduleDeps)
  .factory('ClientFilters', factory);
